import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { apiFetch } from "@core/index";
import { apiEndpoint } from "../utils/constants";

export const useDeleteInvoiceParty = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: { id: string }) => {
      const response = await apiFetch<{
        statusCode: number;
        message: string;
      }>(`${apiEndpoint}/${config.id}`, {
        method: "DELETE",
      });
      return response;
    },
    onSuccess: (response) => {
      if (response.statusCode >= 400) {
        enqueueSnackbar(response.message, {
          variant: "error",
          autoHideDuration: 5000,
        });
      } else {
        enqueueSnackbar("Invoice party deleted successfully.", {
          variant: "success",
          autoHideDuration: 2000,
        });
        queryClient.invalidateQueries({ queryKey: ["invoiceParties"] });
      }
    },
    onError: (error: Error) => {
      enqueueSnackbar(
        "Failed to delete invoice party. Error: " + error.message,
        {
          variant: "error",
          autoHideDuration: 5000,
          preventDuplicate: true,
        },
      );
    },
  });
};
